<template>
  <!-- <div id="doodle">
        interactive doodle coming soon
    </div> -->
  <nav class="mainBorder">
    <a href="/" class="monogram">
      <div class="hRectangle mgline"></div>
      <div class="wRectangle mgline"></div>
      <div class="square mgline">
        <div class="unrotate">
          <span id="jay">J</span>
          <span id="bee">B</span>
        </div>
      </div>
    </a>
    <div class="links navDesktop">
      <router-link to="/" class="link" @click="updateTitle('home')">
        <div class="linkInfo">
          <font-awesome-icon class="logo" icon="fa-solid fa-earth-americas" />
          <p class="linkName">Home</p>
        </div>
      </router-link>
      <router-link to="/about" class="link" @click="updateTitle('about')">
        <div class="linkInfo">
          <font-awesome-icon class="logo" icon="fa-solid fa-route" />
          <p class="linkName">About</p>
        </div>
      </router-link>
      <router-link to="/portfolio" class="link" @click="updateTitle('portfolio')">
        <div class="linkInfo">
          <font-awesome-icon class="logo" icon="fa-solid fa-pen-ruler" />
          <p class="linkName">portfolio</p>
        </div>
      </router-link>
      <router-link to="/contact" class="link last" @click="updateTitle('contact')">
        <div class="linkInfo">
          <font-awesome-icon class="logo" icon="fa-solid fa-map-location-dot" />
          <p class="linkName">contact</p>
        </div>
      </router-link>
    </div>
    <div class="miniContact navDesktop">
      <p>Jennifer Baldwin</p>
      <p>jbldwn@iu.edu</p>
      <p class="boring">&copy;2025 All rights reserved.</p>
    </div>
    <div class="navMobile">
      <div class="hamburger" @click.prevent="toggleVisibility" v-if="!isVisible">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <font-awesome-icon v-if="isVisible" class="navClose" icon="fa-solid fa-xmark" @click.prevent="toggleVisibility" />
    </div>

  </nav>
  <!-- Modal -->
  <div class="navModal" v-if="isVisible" @click.self.prevent="toggleVisibility()" :isDisabled="true">
    <div class="navOptions">
      <div class="options">
        <router-link to="/" class="mobileOption" @click="updateTitle('home')">Home</router-link>
        <router-link to="/about" class="mobileOption" @click="updateTitle('about')">About</router-link>
        <router-link class="mobileOption" to="/portfolio" @click="updateTitle('portfolio')">Portfolio</router-link>
        <router-link class="mobileOption" to="/contact" @click="updateTitle('contact')">Contact</router-link>
        <!-- <a href="index.html" class="mobileOption">Home</a>
        <a href="about.html" class="mobileOption">About</a>
        <a href="portfolio.html" class="mobileOption">Portfolio</a>
        <a href="contact.html" class="mobileOption">Contact</a> -->
      </div>
      <div class="navFooter">
        <p>"Thanks for poking around!"</p>
        <span>- Jennifer Baldwin</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      isDisabled: true,
    };
  },
  emits: ["updateTitle"],
  methods: {
    updateTitle(newTitle) {
      this.$emit("updateTitle", newTitle);
      if (this.isVisible) {
        this.isVisible = !this.isVisible
      }
    },
    toggleVisibility() {
      console.log("is visible?")
      if (this.isDisabled.value) {
        alert("disability caught")
      }
      this.isVisible = !this.isVisible;
    },

  },
};
</script>

<style>
/* Nav Styling */
nav {
  /* Stationary Nav, mount on background */
  position: sticky;
  top: 0;
  /* size */
  min-width: 180px;
  max-width: 13%;
  min-height: 100vh;
  /* spacing */
  padding: 60px 0 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /*  background image and placement */
  background-image: linear-gradient(45deg, rgba(165, 133, 179, 0.7), rgba(165, 133, 179, 0.5), rgba(165, 133, 179, 0.9)), url(../assets/images/navTexture.jpg);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 0px 15px rgb(67, 48, 75));
}

/* Monogram */
nav .monogram {
  text-decoration: none;
  margin: 0 auto;
  min-height: 50px;
  max-height: 80px;
  height: 8vw;
  width: 8vw;
  max-width: 80px;
  min-width: 50px;
  position: relative;
  rotate: -45deg;
}

nav .monogram .mgline {
  border: solid #121b1b 1px;
  margin: 0 auto;
}

nav .monogram .hRectangle {
  height: 100%;
  width: 80%;
}

nav .monogram .wRectangle {
  margin-top: -90%;
  width: 100%;
  height: 80%;
}

nav .monogram .square {
  margin-top: -85%;
  width: 90%;
  height: 90%;
}

nav .monogram .square .unrotate {
  font-family: "besterReg";
  color: #121b1b;
  rotate: 45deg;
  text-transform: capitalize;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Letters */
nav .monogram .square .unrotate #jay {
  align-self: center;
  text-transform: capitalize;
  font-family: "besterReg";
  margin-bottom: 1.5vh;
  font-size: 32px;
}

nav .monogram .square .unrotate #bee {
  align-self: center;
  text-transform: capitalize;
  font-family: "besterReg";
  margin-top: 2.5vh;
  margin-left: -1vh;
  font-size: 32px;
}

/* links styling */
nav .links {
  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-direction: column;
}

nav .links .link {
  width: 100%;
  /* organization */
  display: flex;
  align-items: center;
  justify-content: start;
  /* empty space between links */
  margin-bottom: 15px;
  /* hyperlink reset */
  text-decoration: none;
  color: #121b1b;
  /* font styling */
  font-family: "typeReg";
  text-transform: capitalize;
  font-size: 24px;
}

nav .links .link .linkInfo {
  /* organization */
  display: flex;
  align-items: center;
  padding: 5px 0;
  margin-left: 1.25vw;
}

nav .links .link .linkInfo .logo {
  margin-right: 15px;
}

nav .links .link .linkInfo .linkName {
  margin-bottom: 0;
}

nav .links .link:last-child {
  margin-bottom: 0;
}

/* active styling and hover */
nav .links a.router-link-active {
  font-family: "typeBld";
  background-color: rgba(67, 48, 75, 0.5);
  color: rgba(255, 255, 255, 0.5);
  filter: drop-shadow(0px 0px 10px rgb(67, 48, 75));
  cursor: default;
}

nav .links a.router-link-active .logo {
  color: rgba(255, 255, 255, 0.5);
}

nav .links a.router-link-active:hover {
  font-family: "typeBld";
  filter: drop-shadow(1px 2px 4px rgb(67, 48, 75));
}

/* small contact and legalease */
nav .miniContact {
  /* organization */
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  /* font */
  font-family: "typeBld";
  font-size: 1.5vw;
}

nav .miniContact .boring {
  font-family: sans-serif;
  font-size: 0.75vw;
  margin: 0 15px 0;
}

/* Hamburger Menu - mobile */
nav .navMobile {
  display: none;
}

nav .navMobile {
  width: 50px;
  height: 50px;
}

nav .navMobile .hamburger {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

nav .navMobile .hamburger .bar {
  background-color: rgba(18, 27, 27, 0.65);
  height: 23%;
  width: 100%;
  border-radius: 5px;
}

nav .navMobile .navClose {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 50px;
  color: rgba(18, 27, 27, 0.75);
  cursor: pointer;
}

.navModal {
  /* style */
  min-height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  /* positioning */
  z-index: 5;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /* content alignment */
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 140px;
}

/* modal Content */
.navModal .navOptions {
  z-index: 6;
  /* style */
  height: 80%;
  width: 90%;
  border-radius: 0 0 30px 30px;
  padding: 30px;
  margin-top: -60px;
  /*  background image and placement */
  background-image: linear-gradient(68deg, rgba(205, 160, 92, 0.95), rgba(205, 160, 92, 0.5), rgba(205, 160, 92, 0.75)), url(../assets/images/mobileNav.jpg);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}

.navModal .navOptions .options {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.navModal .navOptions .options a.mobileOption {
  font-family: "typeReg";
  text-decoration: none;
  color: rgb(0, 0, 0);
  background-color: rgba(205, 160, 92, 0.7);
  text-align: center;
  margin-bottom: 4%;
  width: 50%;
  font-size: 4vw;
  border: solid 2px rgb(0, 0, 0);
  border-radius: 8px;
  padding: 5px 15px;
  min-width: 300px;
  height: 13%;
  align-content: center;
}

.navModal .navOptions .options a.mobileOption:hover {
  background-color: rgb(205, 160, 92);
  filter: drop-shadow(1px 2px 4px rgb(59, 47, 27));
}

.navModal .navOptions .navFooter {
  font-size: 2.5vw;
  width: 40%;
  margin: 15px auto 0;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  filter: drop-shadow(1px 2px 4px rgb(205, 160, 92));
  color: rgb(34, 27, 15);
}

.navModal .navOptions .navFooter p {
  font-family: "typeReg";
  align-self: flex-start;
  margin-bottom: 10px;
}

.navModal .navOptions .navFooter span {
  font-family: Arial, Helvetica, sans-serif;
  align-self: flex-end;
  color: rgba(0, 0, 0, 0.8);
}

/* link and monogram hover */
.link:hover .linkName {
  font-family: "typeBld";
}

.link:hover .logo {
  filter: drop-shadow(1px 2px 4px rgb(67, 48, 75));
}

.monogram:hover {
  filter: drop-shadow(1px 2px 4px rgb(67, 48, 75));
}

.active.link .logo,
.active.link .linkName {
  filter: none !important;
}

@media only screen and (min-width:915px) {
  .navModal {
    display: none;
  }
}

/* Tablet */
@media only screen and (max-width: 915px) {
  nav {
    /* size */
    min-height: fit-content;
    min-width: 100vw;
    /* spacing */
    padding: 20px 30px;
    position: fixed;
    z-index: 99;
    /* alignmnet */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  nav .monogram {
    margin: 0;
  }

  nav .links {
    display: none;
  }

  nav .miniContact {
    display: none;
  }

  nav .navMobile {
    display: flex;
  }

  nav .monogram .mgline {
    border: solid rgba(18, 27, 27, .7) 1px;
  }

  nav .monogram .square .unrotate #jay,
  nav .monogram .square .unrotate #bee {
    filter: drop-shadow(1px 2px 5px rgb(240, 240, 255));
    font-weight: bold;
  }

  nav .navClose {
    /* display: flex; */
  }

  .navModal {
    /* display: flex; */
  }

  .navModal .navOptions .options a.mobileOption {
    width: 65%;
  }

  .navModal .navOptions .navFooter {
    font-size: 3.5vw;
    min-font-size: 80px;
    width: 70%;
  }
}

/* Mobile */
@media only screen and (max-width: 560px) {
  nav {
    padding: 15px 25px;
  }

  nav .navMobile {
    width: 40px;
    height: 40px;
  }

  /* .navModal {
    display: flex;
  } */

  .navModal .navOptions .options a.mobileOption {
    width: 80%;
    font-size: 6vw;
  }

  .navModal .navOptions .navFooter {
    font-size: 4.5vw;
    width: 90%;
  }
}

/* End Nav Styling */
</style>
